import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { getJwt } from "@/shared/auth/getJwt.helper";

export const createAxiosClient = async () => {
  const jwt = await getJwt();
  const uuid = uuidv4();

  const baseURL = import.meta.env.VITE_MULESOFT_API_BASE_URL;

  return axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${jwt}`,
      "X-CORRELATION-ID": uuid,
    },
  });
};

export const createGuestApiAxiosClient = async () => {
  const uuid = uuidv4();

  const baseURL = import.meta.env.VITE_MULESOFT_GUEST_API_BASE_URL;

  return axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CORRELATION-ID": uuid,
    },
  });
};
